<template>
  <div>
    <div class="row">
      <div :class="dataId ? 'col' : 'col-sm-12'">
        <div
          :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table border-radius-20 p-3 position-relative`"
        >
          <Loading v-if="loading" />
          <h3 class="my-3">
            {{ dataId ? `Editar ${currentName ? currentName : "-"}` : "" }}
          </h3>
          <div class="form-floating text-dark my-3">
            <input
              v-model="form.name"
              type="text"
              class="form-control border-secondary"
              id="formName"
              maxlength="55"
            /><span class="character-counter" v-if="form.name"
              >{{ form.name.length }} / 55</span
            >
            <label for="formName">Nombre</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("name") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <textarea
              v-model="form.description"
              class="form-control border-secondary text-area-padding"
              placeholder="Leave a comment here"
              id="formDescription"
              style="height: 100px"
              maxlength="255"
            ></textarea
            ><span class="character-counter" v-if="form.description"
              >{{ form.description.length }} / 255</span
            >
            <label class="label-form-description" for="formDescription"
              >Descripción</label
            >
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("description") }}
            </p>
          </div>
          <div class="d-flex justify-content-end">
            <button
              type="button"
              @click="saveData()"
              class="btn btn-primary"
              :disabled="validateData()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mt-5" v-if="dataId">
        <h3 class="my-3">Proyectos</h3>
        <select
          v-model="projectId"
          class="form-select border-secondary"
          aria-label="Seleccionar Proyecto"
          @change="setTreeData"
          v-if="projectList"
        >
          <template
            v-for="project of projectList"
            :key="`projectList${project.id}`"
          >
            <option :value="project.id">{{ project.name }}</option>
          </template>
        </select>
        <DataTableFolders
          :url="buildUrl()"
          edit-url="edit-role-form"
          :role-id="dataId"
          :project-id="projectId"
          :folders="getFolders"
          :folder-list="getFolderList"
          v-if="getFolderStructureId"
          :key="'datatable-project-' + projectId"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Loading from "@/components/Loading.vue";
import DataTableFolders from "@/components/DataTableFolders.vue";
export default {
  name: "role-form",
  components: { DataTableFolders, Loading },
  emits: ["setData", "setBreadcrumb"],
  props: {
    dataId: { default: null },
  },
  data() {
    return {
      breadcrumb: [{ text: "Roles", link: { name: "roles" } }],
      form: { name: null, description: null },
      currentName: "",
      folders: [],
      folderList: [],
      projectList: [],
      projectId: null,
      projects: [],
      selectedItems: [],
      componentKey: 0,
      loading: false,
    };
  },
  created() {
    if (this.dataId) {
      this.setData();
      this.breadcrumb.push({ text: "Editar", link: { name: "roles" } });
    } else {
      this.breadcrumb.push({ text: "Crear", link: { name: "roles" } });
    }
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  methods: {
    setData(dataId) {
      let app = this;
      this.axios
        .get(`roles/${dataId ? dataId : this.dataId}`)
        .then((result) => {
          app.form = result.data.body;
          app.currentName = app.form.name;
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .get(`projects`)
        .then((result) => {
          app.projectList = result.data.body.data;
          app.projectId = app.projectList[0].id;
          app.setTreeData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setTreeData() {
      let app = this;
      this.axios
        .get(`folder_structures/${this.getFolderStructureId}/folders`)
        .then((result) => {
          // app.form = result.data.body
          app.folders = result.data.body;
          app.currentName = app.form.name;
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .get(`folder_structures/${this.getFolderStructureId}/list_folders`)
        .then((result) => {
          app.folderList = result.data.body;
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      let app = this;
      this.loading = true;
      if (this.dataId) {
        this.axios
          .put(`roles/${this.dataId}`, {
            role: this.form,
          })
          .then(() => {
            app.loading = false;
            app.$router
              .push({
                name: "roles",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      } else {
        this.axios
          .post("roles", { role: this.form })
          .then((result) => {
            app.loading = false;
            app.$router
              .push({
                name: "edit-role-form",
                params: {
                  dataId: result.data.body.id,
                  alertMsg: "Guardado correcto!",
                },
              })
              .catch();
            app.setData(result.data.body.id);
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      }
    },
    validateData() {
      if (this.form.name && this.form.description) return false;
      return true;
    },
    validateDataMessage(field) {
      switch (field) {
        case "name":
          if (!this.form.name) return "Debe ingresar un nombre";
          break;
        case "description":
          if (!this.form.description) return "Debe ingresar una descripción";
          break;
      }
    },
    buildUrl() {
      return `folder_structures/${this.getFolderStructureId}/list_folders_in_roles`;
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    getFolderList() {
      return this.folderList;
    },
    getFolders() {
      return this.folders;
    },
    getFolderStructureId() {
      if (this.projectList && this.projectId) {
        let folderStructureId = this.projectList.find(
          (find) => find.id == this.projectId
        );
        return folderStructureId.folder_structure_id;
      }
      return null;
    },
  },
};
</script>
